import "./LandingSections.css";

function LandingSection({ children, className = "" }) {
  return (
    <section className={`caf-section caf-section--elevated landing-section ${className}`.trim()}>
      <div className="caf-section__block caf-section__block--spaced">{children}</div>
    </section>
  );
}

export default LandingSection;
